import { Controller } from 'react-hook-form';
import {
  Autocomplete,
  ClickOutsideDetector,
  IconLoader,
  InputText,
  Select,
} from '@ui/src';
import { LinkedClientFormTypes } from './types';

import cn from './styles.module.css';

let timeout: NodeJS.Timeout;

const LinkedClientForm = ({
  control,
  pspPartners,
  pspPartnerId,
  errors,
  autocompleteList,
  isLoading,
  onSearch,
  setSelectedOrganization,
  onClear,
  setExternalOrganizationsListVisible,
  externalOrganizationSearch,
  setExternalOrganizationSearch,
  getPspIntegrationOrganizationsAction,
  pspIntegrationOrganizationsList,
  externalOrganizationsListVisible,
  organizationsIsLoading,
  organizationsIsFetching,
}: LinkedClientFormTypes) => (
  <>
    <div className={cn.linkedCustomerFormGroup}>
      <Controller
        control={control}
        defaultValue=""
        name="pspPartnerId"
        render={({ field: { name, value, onChange } }) => (
          <Select
            name={name}
            list={pspPartners}
            value={value}
            title="Bank"
            placeholder="Select Bank"
            onChange={onChange}
            error={errors?.pspPartnerId?.message}
          />
        )}
      />
    </div>
    <div className={cn.linkedCustomerFormGroup}>
      <Controller
        control={control}
        defaultValue=""
        name="organizationId"
        render={({ field: { name, onChange, value } }) => (
          <Autocomplete
            name={name}
            value={value}
            list={autocompleteList}
            placeholder="Enter customer name or company name..."
            isLoading={isLoading}
            title="Customer"
            onSearch={(text) => onSearch(text)}
            onChange={(e) => {
              onChange(e.target.value);

              const organization = autocompleteList?.find(
                (item) => item.value === e.target.value,
              );

              if (organization) {
                setSelectedOrganization(organization);
              }
            }}
            onClearClick={() => {
              onClear();

              setSelectedOrganization(undefined);
            }}
            error={errors?.organizationId?.message}
            disabled={!pspPartnerId}
            fullWidth
            withClearButton
          />
        )}
      />
    </div>
    <div className={cn.linkedCustomerFormGroup}>
      <Controller
        control={control}
        defaultValue=""
        name="externalId"
        render={({ field: { onChange } }) => (
          <ClickOutsideDetector
            setOptionsListVisible={setExternalOrganizationsListVisible}
          >
            <div className={cn.searchExternalOrganizationWrapper}>
              <InputText
                name="searchName"
                value={externalOrganizationSearch}
                title="External Customer"
                placeholder="Enter name..."
                onChange={(e) => {
                  clearTimeout(timeout);

                  setExternalOrganizationSearch(e.target.value);

                  if (e.target.value) {
                    timeout = setTimeout(() => {
                      getPspIntegrationOrganizationsAction({
                        name: e.target.value,
                      });
                    }, 700);
                  }
                }}
                onFocus={() => {
                  if (pspIntegrationOrganizationsList?.length) {
                    setExternalOrganizationsListVisible(true);
                  }
                }}
                error={errors?.externalId?.message}
                disabled={!pspPartnerId}
              />
              {externalOrganizationsListVisible && (
                <div className={cn.organizationList}>
                  {(organizationsIsLoading || organizationsIsFetching) && (
                    <div className={cn.organizationListLoader}>
                      <IconLoader />
                    </div>
                  )}
                  {!organizationsIsLoading &&
                    !organizationsIsFetching &&
                    pspIntegrationOrganizationsList?.map((item) => (
                      <button
                        type="button"
                        className={cn.organizationButton}
                        key={item.externalId}
                        onClick={() => {
                          setExternalOrganizationsListVisible(false);
                          onChange(item.externalId);
                          setExternalOrganizationSearch(item.name);
                        }}
                      >
                        <div className={cn.organizationButtonLeft}>
                          {item.name}
                        </div>
                        <div className={cn.organizationButtonRight}>
                          {item.organizationType
                            .split('_')
                            ?.map(
                              (organizationType) =>
                                `${organizationType.charAt(0)}${organizationType.slice(1).toLowerCase()}`,
                            )
                            .join(' ')}
                        </div>
                        <div className={cn.externalOrganizationId}>
                          {item.externalId}
                        </div>
                      </button>
                    ))}
                </div>
              )}
            </div>
          </ClickOutsideDetector>
        )}
      />
    </div>
  </>
);

export default LinkedClientForm;
